import { Box, CircularProgress } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';

import Autocomplete from 'shared/components/widgets/autocomplete';
import Input from 'shared/components/widgets/input';
import Button from 'shared/components/widgets/button';
import AutocompleteContainer from 'shared/components/widgets/autocomplete-container';
import FileRegisterButton from '@components/file-management/file-management-list/file-register-button.tsx';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const ExternalDeliveryFilesFilter = ({ getFilteredList, isCreateAction, createActionPath, isLoading }) => {
  const location = useLocation()
  const isRefresh = location?.state?.refresh
  const { control, handleSubmit, watch, setValue } = useForm({
    defaultValues: {
      schLfsKind: 'all',
      schDeptCd: 'all',
      schGroup: 'subject',
      schKeyword: '',
    },
  });

  const classificationFilterData = [
    { label: '전체', value: 'all' },
    { label: '제안서', value: 'proposal' },
    { label: '브로셔', value: 'brochure' },
    { label: '패치파일', value: 'patch_file' },
    { label: '설치파일', value: 'install_file' },
    { label: '가이드문서', value: 'guide' },
  ];

  const departmentFilterData = [
    { label: '전체', value: 'all' },
    { label: 'PO본부', value: 'DEP1000001' },
    { label: 'PD본부', value: 'DEP1000002' },
    { label: 'LRD본부', value: 'DEP1000003' },
    { label: '기술본부', value: 'DEP1000004' },
    { label: '컨설팅본부', value: 'DEP1000005' },
    { label: '신사업개발본부', value: 'DEP1000006' },
    { label: '재무전략실', value: 'DEP1000007' },
    { label: '경영지원실', value: 'DEP1000008' },
    { label: '마케팅팀', value: 'DEP1000009' },
    { label: '전략실', value: 'DEP1000010' },
    { label: '법무감사실', value: 'DEP1000011' },
    { label: '전사고문', value: 'DEP1000012' },
    { label: '마크애니 체인버스', value: 'DEP1000013' },
  ];


  /*const searchTermTargetFilterData = [
    { label: '업로드 제목', value: 'subject' },
    { label: '파일명', value: 'filename' },
    { label: '업로드 제목 + 파일명', value: 'subject_filename' },
  ];*/

  const keyword = watch('schKeyword');

  // const resetFilter = () => {
  //   reset()
  //   getFilteredList([
  //     { key: 'page', value: 1 },
  //     {
  //       key: 'schLfsKind',
  //       value: '',
  //     },
  //     { key: 'schDeptCd', value: '' },
  //     { key: 'schGroup', value: 'subject_filename' },
  //     { key: 'schKeyword', value: '' },
  //   ]);
  // }

  useEffect(() => {
    if (isRefresh) {
      setValue('schLfsKind', 'all')
      setValue('schDeptCd', 'all')
      setValue('schGroup', '')
      setValue('schKeyword', '')
    }
  }, [isRefresh])

  const onSubmit = (data: any) => {
    const { schLfsKind, schDeptCd, schKeyword } = data;
    getFilteredList([
      { key: 'page', value: 1 },
      {
        key: 'schLfsKind',
        value: schLfsKind === 'all' ? '' : schLfsKind,
      },
      { key: 'schDeptCd', value: schDeptCd === 'all' ? '' : schDeptCd },
      { key: 'schGroup', value: 'subject_filename' },
      { key: 'schKeyword', value: schKeyword },
    ]);
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      display="flex"
      flexDirection="row"
      alignItems="flex-end"
      gap={3}
      marginBottom="40px"
    >
      {/* CLASSIFICATION */}
      <AutocompleteContainer>
        <Controller
          name="schLfsKind"
          control={control}
          render={({ field }) => {
            return (
              <Autocomplete
                {...field}
                title="분류"
                options={classificationFilterData}
                defaultValue={
                  classificationFilterData.find(
                    (el) => el.value === field.value,
                  ) ?? {
                    label: '전체',
                    value: 'all',
                  }
                }
                value={field?.value ?? 'all'}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                onChange={(_, newValue, reason) => {
                  field.onChange(newValue?.value);
                  if (reason === 'clear') {
                    field.onChange('all');
                  }
                }}
              />
            );
          }}
        />
      </AutocompleteContainer>
      {/* DEPARTMENT */}
      <AutocompleteContainer>
        <Controller
          name="schDeptCd"
          control={control}
          render={({ field }) => {
            return (
              <Autocomplete
                {...field}
                title="부서"
                options={departmentFilterData}
                defaultValue={
                  departmentFilterData.find(
                    (el) => el.value === field.value,
                  ) ?? {
                    label: '전체',
                    value: 'all',
                  }
                }
                value={field?.value ?? 'all'}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                onChange={(_, newValue, reason) => {
                  field.onChange(newValue?.value);
                  if (reason === 'clear') {
                    field.onChange('all');
                  }
                }}
              />
            );
          }}
        />
      </AutocompleteContainer>
      {/* SEARCH */}
      <Box sx={{ maxWidth: '300px' }} flex={1}>
        <Controller
          name="schKeyword"
          control={control}
          render={({ field }) => {
            return (
              <Input
                {...field}
                isSearch
                keyword={keyword}
                placeholder="검색어를 입력해 주세요."
                clearAction={() => {
                  field.onChange('')
                }}
                value={field.value}
                showErrorMsg={false}
              />
            );
          }}
        />
      </Box>
      <Button
        disabled={isLoading}
        variant="outlined"
        type="submit">
        {isLoading
          ?
          <CircularProgress size={20} color='secondary' />
          :
          '검색하기'
        }
      </Button>

      <FileRegisterButton isCreateAction={isCreateAction} createActionPath={createActionPath} />

    </Box>
  );
};

export default ExternalDeliveryFilesFilter;
